import { PromiseClient } from 'hub-http/adapters/promiseClient';
import { createRpcClientV2 } from 'rpc-client-utils';

import { shareDocumentRpc } from '../../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsDocumentService';

const getURI = (contentId: number) =>
  `presentations/v1/deck/${contentId}/share`;

const getInsertContent = ({
  shortLink,
  name,
}: {
  shortLink: string;
  name: string;
}) => {
  return {
    url: shortLink,
    text: name,
  };
};

export function renderDocument({
  httpClient,
  contactEmail,
  contentId,
  requireEmail = true,
  allowDownload = true,
}: {
  httpClient: PromiseClient;
  contactEmail: string;
  contentId: number;
  requireEmail?: boolean;
  allowDownload?: boolean;
}) {
  const skipForm = !requireEmail;
  const promise = httpClient
    .post(getURI(contentId), {
      query: {
        sharedWith: contactEmail,
        skipForm,
        hasDownload: allowDownload,
      },
    })
    .then((res: any) => {
      return getInsertContent(res);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
  return promise;
}

export async function renderDocumentCHIRP({
  httpClient,
  contactEmail,
  contentId,
  documentName,
  requireEmail = true,
  allowDownload = true,
}: {
  httpClient: PromiseClient;
  contactEmail: string;
  contentId: number;
  documentName: string;
  requireEmail?: boolean;
  allowDownload?: boolean;
}) {
  const rpcClient = createRpcClientV2({ hubHttpClient: httpClient });
  const response = await rpcClient.call(shareDocumentRpc, {
    request: {
      documentId: contentId,
      name: documentName,
      sharedWithEmail: contactEmail,
      hasDownload: allowDownload,
      skipForm: !requireEmail,
    },
  });
  return getInsertContent({
    shortLink: response.shortLink ?? '',
    name: response.name,
  });
}
